module.exports = __webpack_public_path__ + "img/title.201a932e.svg";